import styled from 'styled-components'
import arrow from '../../components/atoms/DropDownArrow/dropDownArrow.png'

export const Header = styled.h3`
 align-items: center;
`

export const Container = styled.div`
`

export const DropdownBox = styled.div`  
 margin-top: 2rem;
 justify-content: center;
 align-items: center;
 display: flex;
 gap: 1rem;
 `

 export const Dropdown = styled.select`
 font-size: 1rem;
  font-family: sans-serif;
  font-weight: 700;
  color: #444;
  line-height: 1.3;
  padding: .6em 1.4em .5em .8em;
  width: 10%;
  max-width: 10%; 
  box-sizing: border-box;
  border:none;
  border-radius: .5em;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-color: transparent;
 
  linear-gradient(to bottom, #ffffff 0%,#e5e5e5 100%);
  background-repeat: no-repeat, repeat;
 
  background-position: right .7em top 50%, 0 0;
 
  background-size: 1em auto, 100%;
  appearance: none;
  background-image: url(${arrow});
 `